import experiments from '@reverbdotcom/commons/src/experiments';
import { CoreMarketplaceCombinedMarketplaceSearch } from '../../schemas/rql';
import { isNewListing } from '@reverbdotcom/commons/src/newListingNudge';

export const ALWAYS_TRACKED_EXPERIMENTS = [
  experiments.LISTING_CARD_LOCATION,
  experiments.DUMMY,
  experiments.MV_DUMMY_COOKIE_BUCKETING,
  experiments.MARKETPLACE_GRID_ADS,
  experiments.LISTINGS_QUERY_REWRITE_V2,
  experiments.LISTINGS_SEARCH_BEST_MATCH_SIGNALS_V3,
  experiments.LTS_V3_MARKETPLACE,
  experiments.AA_MARKETPLACE_SESSION_BUCKETING,
  experiments.PRICE_DROP_FILTER,
  experiments.SHOP_PAGE_PINNED_SEARCH,
];

export function pageViewTrackedExperiments(listingsSearchResult: CoreMarketplaceCombinedMarketplaceSearch.ListingsSearch): string[] {
  const exps = [].concat(ALWAYS_TRACKED_EXPERIMENTS);

  if (listingsSearchResult.listings.some(listing => isNewListing(listing))) {
    exps.push(experiments.RECENTLY_LISTED_SIGNAL_MARKETPLACE_V2);
  }

  return exps;
}
